module.exports = "/assets/career/team/dorota.png?y+uJ8t1";